import { BankHealthTab } from "@/components/bank-health-tab";
import { useQuery } from "@tanstack/react-query";
import { AccessRestricted } from "@/components/access-restricted";
import { useTranslation } from "react-i18next";

export default function BankHealthPage() {
  const { t } = useTranslation(["bank", "common"]);
  const { data: user } = useQuery<any>({ queryKey: ["/api/auth/me"], retry: false });

  if (user?.memberPermissions && !user.memberPermissions.financialAccess) {
    return <AccessRestricted feature={t("bank:page.title")} />;
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold tracking-tight">{t("bank:page.title")}</h1>
        <p className="text-sm text-muted-foreground mt-1">
          {t("bank:page.subtitle")}
        </p>
      </div>
      <BankHealthTab />
    </div>
  );
}
